/* global Ad */
import createLatLngBounds from '@PROJECT_ROOT/assets/desktop/js/search/mapsearch/LatLngBounds';
import isGoogleLocationId from '@PROJECT_ROOT/assets/shared/js/PrivateAccommodation/googleLocationId';

/**
 * Vraća objekt za upravljanje filter formom na pretrazi privatnog smještaja.
 *
 * Plan je većinu funkcionalnosti te filter forme prebaciti ovdje.
 * Ova funkcija i metode objekta kojeg vraća *moraju* biti idempotentne, tj. mogu se pozvati više puta i efekt će biti
 * isti kao da smo ih pozvali samo jednom.
 *
 * @param {function} $ jQuery
 * @param {function} funkcija koja provjerava je li id lokacije google mjesto (privremeno, dok ne uvedemo webpack)
 *
 * @return {object}
 */
export function getPrivateFilterForm($, isGoogleLocationId) {
    if (!$ || typeof $ !== 'function') {
        throw new TypeError('No jQuery provided');
    }

    function areAllCoordinatesSet() {
        return Boolean($('#SearchPrivateFilterForm_sw_lng').val() && $('#SearchPrivateFilterForm_sw_lat').val()
            && $('#SearchPrivateFilterForm_ne_lat').val() && $('#SearchPrivateFilterForm_ne_lng').val());
    }

    function clearMapCoordinates() {
        $('#SearchPrivateFilterForm_ne_lat').val('');
        $('#SearchPrivateFilterForm_ne_lng').val('');
        $('#SearchPrivateFilterForm_sw_lat').val('');
        $('#SearchPrivateFilterForm_sw_lng').val('');
    }

    function getLocationId() {
        if (process.env.NODE_ENV !== 'production') {
            if ($('#quickLocationId').val() !== $('#SearchPrivateFilterForm_location_id').val()
                && $('#quickLocationId').val()) {
                console.error('Different location id in quick form and filter form.');
            }
        }

        return $('#SearchPrivateFilterForm_location_id').val();
    }

    function resetZeroPlaceRadiusToDefaultAfterLocationChange() {
        var locationIdBeforeChange = getLocationId();

        function resetPlaceRadiusToDefault() {
            var locationIdAfterChange = getLocationId();
            if(locationIdBeforeChange !== locationIdAfterChange) {
                $('#SearchPrivateFilterForm_pl_r').val(20);
                $('#quickRadius').val(20);
            }
            locationIdBeforeChange = locationIdAfterChange;
        }

        // Change eventovi moraju biti vezani na location polja umjesto location_id, jer se na promjenu location polja u
        // nekim slučajevima vrši submit forme.
        $('#SearchPrivateFilterForm_location')
            .off('change.resetPlaceRadiusToDefault')
            .on('change.resetPlaceRadiusToDefault', resetPlaceRadiusToDefault);
        $('#quickLocation')
            .off('change.resetPlaceRadiusToDefault')
            .on('change.resetPlaceRadiusToDefault', resetPlaceRadiusToDefault);
    }

    return {
        clearMapCoordinatesFilter: function clearMapCoordinatesFilter() {
            clearMapCoordinates();
        },
        setFilterMapCoordinates: function setFilterMapCoordinates(viewport) {
            if (!viewport) {
                clearMapCoordinates();
                return;
            }

            $('#SearchPrivateFilterForm_ne_lat').val(viewport.getNorthEast().lat());
            $('#SearchPrivateFilterForm_ne_lng').val(viewport.getNorthEast().lng());
            $('#SearchPrivateFilterForm_sw_lat').val(viewport.getSouthWest().lat());
            $('#SearchPrivateFilterForm_sw_lng').val(viewport.getSouthWest().lng());
        },
        setLocation: function setLocation(name, id) {
            $('#quickLocation').val(name);
            $('#SearchPrivateFilterForm_location').val(name);

            if (typeof id !== 'undefined') {
                $('#quickLocationId').val(id);
                $('#SearchPrivateFilterForm_location_id').val(id);
            }

            if (name === '' && id === '') {
                $('#SearchPrivateFilterForm_pl_r').val('');
            }
        },
        isSearchByMap: function isSearchByMap() {
            if ($('#quickLocation').val() || $('#SearchPrivateFilterForm_location').val()
                || $('#quickLocationId').val() || $('#SearchPrivateFilterForm_location_id').val()) {
                return false;
            }

            return areAllCoordinatesSet();
        },
        getViewport: function getViewport() {
            if (!areAllCoordinatesSet()) {
                return null;
            }

            return createLatLngBounds({
                north: $('#SearchPrivateFilterForm_ne_lat').val(),
                east: $('#SearchPrivateFilterForm_ne_lng').val(),
                south: $('#SearchPrivateFilterForm_sw_lat').val(),
                west: $('#SearchPrivateFilterForm_sw_lng').val(),
            });
        },
        getLocationId: getLocationId,
        isSearchByPlace: function isSearchByPlace() {
            var locationId = getLocationId();

            return isGoogleLocationId(locationId) || locationId.substr(0, 3) === 'pl-';
        },
        setPlaceRadiusToDefaultIfNotSet: function setPlaceRadiusToDefaultIfNotSet() {
            if (!$('#SearchPrivateFilterForm_pl_r').val()) {
                $('#SearchPrivateFilterForm_pl_r').val(20);
                $('#quickRadius').val(20);
            }
        },
        resetZeroPlaceRadiusToDefaultAfterLocationChange: resetZeroPlaceRadiusToDefaultAfterLocationChange,
        isSearchByOurTown: function isSearchByOurTown() {
            var locationId = getLocationId();

            return locationId.substr(0, 3) === 'pl-';
        },
        hideDiscountChoicesNotOfferedToGuest: function hideDiscountChoices () {
            $('[name="SearchPrivateFilterForm[dc_t][]"]').each(function (index, element) {
                if ($(element).val() !== 'all_discounts') {
                    $(element).parent().hide();
                }
            });
        },
        hideCategoryChoicesNotOfferedToGuest: function hideCategoryChoices () {
            $('[name="SearchPrivateFilterForm[category][]"]').each(function (index, element) {
                if (['family_friendly', 'robinson', 'quiet', 'beach'].indexOf($(element).val()) === -1) {
                    $(element).parent().hide();
                }
            });
        },
        hideFoodChoicesNotOfferedToGuest: function hideFoodChoices () {
            $('[name="SearchPrivateFilterForm[food][]"]').each(function (index, element) {
                if ($(element).val() !== '1') {
                    $(element).parent().hide();
                }
            });
        },
        calculateToAndFromDates: function calculateToAndFromDates(from, to) {
            var fromDate = new Date(from);
            var toDate = new Date(to);
            var now = new Date();
            var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

            if (isNaN(fromDate) || isNaN(toDate)) {
                return { from: null, to: null };
            }

            if(fromDate > toDate || fromDate < today) {
                return { from: null, to: null };
            }

            return { from: fromDate, to: toDate };
        },
    };
}

export default function configureGetPrivateFilterForm() {
    return getPrivateFilterForm.bind(null, jQuery, isGoogleLocationId);
}
